import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  ItemListProvider,
} from 'Views/Page/Content/Templates/GenericTableTemplate/MainContent/ItemListPicker/ItemList/ItemContext';
import PlannerTransitionHouseholdContent from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content';

const PlannerTransitionHouseholdTemplate = () => {
  const {
    isInitializing,
    initializingError,
    pageContentResource: plannerTransitionHouseholdPageResource,
  } = usePageContentContext();

  return (
    <ItemListProvider>
      <DataContainer
        component={PlannerTransitionHouseholdContent}
        componentProps={{
          plannerTransitionHouseholdPageResource,
        }}
        loading={isInitializing}
        loadingError={initializingError}
      />
    </ItemListProvider>
  );
};

PlannerTransitionHouseholdTemplate.defaultProps = {
};

PlannerTransitionHouseholdTemplate.propTypes = {
};

export default PlannerTransitionHouseholdTemplate;
